<ng-container *ngIf="!requestCompleted && !requestFailed">
  <form class="forgot-password-form" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <h1 class="headline-large">Forgot password</h1>
    <p>Please provide your email and we'll send you reset password link.</p>
    <mat-form-field class="form-field">
      <mat-label>Email</mat-label>
      <input type="text" aria-labelledby="Email" matInput formControlName="email" />
    </mat-form-field>
    <mat-error *ngIf="email.touched && email.invalid">{{ getErrorMessage() }}</mat-error>
    <button
      mat-flat-button
      aria-label="Sign in"
      class="buttons"
      type="submit"
      color="primary"
      [isBusy]="isBusy"
      tabindex="0"
      [disabled]="!formGroup.valid"
    >
      Submit
    </button>
    <a class="back-to-login" [routerLink]="loginUrl">Back to login</a>
  </form>
</ng-container>

<ng-container *ngIf="requestCompleted">
  <p class="p-2">
    If an account is found with the provided email address, a message with instructions for resetting your password will be sent
    momentarily. If you do not receive an email within an hour, please try to reset your password again.
  </p>
  <a class="back-to-login" [routerLink]="loginUrl">Back to login</a>
</ng-container>

<ng-container *ngIf="requestFailed">
  <p class="p-2">
    An account cannot be found with the email address and password previously provided. If there is an active account associated with your
    email address, please visit the link below to request assistance. <br />
    <a href="https://achieve-family-portal-achievesupport.happyfox.com/new" target="_blank">ACHIEVE Family Portal Support Request link</a>
  </p>
  <a class="back-to-login" [routerLink]="loginUrl">Back to login</a>
</ng-container>
